<template>
  <v-container class="pa-0 ma-0 registro-viajero" fluid>
    <v-toolbar class="slide-card-up mb-8" dense color="#FBFAF1" style="min-height: 80px;">
      <v-spacer />
      <v-toolbar-title class="mt-6 text-center"><img src="../assets/logo7.svg" alt="Rutas Meigas" style="height: 60px;"></v-toolbar-title>
      <v-spacer />
    </v-toolbar>
    <v-container>
      <v-progress-linear v-if="cargando" indeterminate class="mb-4" :aria-label="copy.cargando" />
      <v-alert v-if="errorCarga" type="error" outlined>{{ errorCarga }}
        <v-btn small text @click="cargar">{{ copy.reintentar }}</v-btn>
      </v-alert>
      <template v-if="datos">
        <h1 class="text-h5 text-center mb-4">{{ copy.titulo }}</h1>
        <p class="text-center">{{ copy.reserva }}: <strong>{{ datos.reserva.codigo }}</strong></p>
        <v-alert v-if="datos.completado" type="success" outlined>{{ copy.completado }}</v-alert>
        <v-row class="mt-0 mb-2"><v-col><p style="text-align: start;">{{ $t('mensajes.datos_pasajeros.titulo') }}</p></v-col></v-row>
        <v-alert v-if="errorEnvio" type="error" outlined role="alert">{{ errorEnvio }}
          <v-btn v-if="conflicto" small text @click="cargar">{{ copy.recargar }}</v-btn>
        </v-alert>
        <v-form ref="formulario" @submit.prevent="guardar">
          <v-row justify="center">
            <v-col cols="12" md="6" class="d-flex">
              <registro-viajero-card :pasajero="formulario" :numero="1" :mostrar-formulario-reducido="datos.formulario_reducido"
                :is-spanish="datos.idioma === 'ES'" :codigos-pais="codigosPais" :provincias-espana="provinciasEspana"
                :disabled="bloqueado" :reglas="reglas" :errores="errores" :is-required-field-missing="campoInvalido" />
            </v-col>
          </v-row>
          <v-row justify="end" class="mt-4" v-if="!datos.completado">
            <v-chip link large role="button" :disabled="bloqueado || !formularioValido" @click="guardar"
              class="ma-2 px-8 mr-8" :color="formularioValido ? '#191970' : 'grey'"
              :text-color="formularioValido ? '#FF9C00' : 'white'" style="font-size: 1.2rem;">
              {{ copy.guardar }} <v-icon size="2rem" right>mdi-arrow-right</v-icon>
            </v-chip>
          </v-row>
        </v-form>
        <v-row justify="start" class="mx-4 mt-12 mb-12"><p style="font-size: .8rem; text-align: start;">{{ $t('mensajes.datos_pasajeros.politica_privacidad') }}</p></v-row>
      </template>
    </v-container>
  </v-container>
</template>

<script>
import RegistroViajeroCard from '@/components/RegistroViajeroCard.vue';
import { camposRegistroViajero, obtenerRegistroViajero, completarRegistroViajero } from '@/services/registroViajero';

export default {
  components: { RegistroViajeroCard },
  data: () => ({ datos: null, formulario: {}, cargando: false, guardando: false, errorCarga: '', errorEnvio: '', errores: {}, conflicto: false, solicitud: 0 }),
  computed: {
    codigosPais() { return this.$store && this.$store.getters['paises/getCodigosPais'] || []; },
    provinciasEspana() { return this.$store && this.$store.getters['paises/getProvinciasEspana'] || []; },
    formularioValido() { return this.datos && this.campos.every(campo => !this.campoInvalido(this.formulario, campo)); },
    copy() { return this.$t('mensajes.registro_individual'); },
    bloqueado() { return this.cargando || this.guardando || this.conflicto || !!(this.datos && this.datos.completado); },
    campos() {
      if (this.datos.formulario_reducido) return ['nombre', 'primer_apellido', 'segundo_apellido', 'numero_documento', 'telefono_movil'];
      return camposRegistroViajero.filter(campo => !['soporte_documento', 'parentesco'].includes(campo) || this.esEspanol);
    },
    esEspanol() { return this.datos && this.datos.idioma === 'ES' && ['españa', 'espana', 'es'].includes(String(this.formulario.nacionalidad || '').trim().toLowerCase()); },
    requiereSoporte() {
      return this.datos && !this.datos.formulario_reducido && this.datos.idioma === 'ES' &&
        ['españa', 'espana', 'es'].includes(String(this.formulario.nacionalidad || '').trim().toLowerCase()) && this.formulario.tipo_documento === 'DNI';
    },
  },
  watch: { '$route.fullPath': { immediate: true, handler() { this.datos = null; this.cargar(); } } },
  beforeDestroy() { this.solicitud++; },
  methods: {
    campoInvalido(pasajero, campo) { return this.reglas(campo).some(regla => regla(pasajero[campo]) !== true); },
    reglas(campo) {
      const obligatorios = this.datos.formulario_reducido ? ['nombre', 'primer_apellido', 'numero_documento', 'telefono_movil'] :
        ['nombre', 'primer_apellido', 'sexo', 'fecha_nacimiento', 'tipo_documento', 'numero_documento', 'telefono_movil', 'email', 'direccion', 'poblacion', 'provincia', 'codigo_postal', 'nacionalidad'];
      const rules = [];
      if (obligatorios.includes(campo) || (campo === 'soporte_documento' && this.requiereSoporte)) rules.push(v => !!String(v || '').trim() || this.copy.obligatorio);
      if (campo === 'email') rules.push(v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || this.copy.email);
      if (campo === 'fecha_nacimiento') rules.push(v => !v || this.fechaValida(v) || this.copy.fecha);
      return rules;
    },
    fechaValida(valor) {
      const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(valor || '');
      if (!match) return false;
      const [ , d, m, y] = match.map(Number); const fecha = new Date(y, m - 1, d);
      return fecha.getFullYear() === y && fecha.getMonth() === m - 1 && fecha.getDate() === d && fecha <= new Date();
    },
    aplicar(datos) {
      if (!datos || !datos.pasajero || !datos.reserva || !datos.version_pasajero) throw new Error('Respuesta incompleta');
      this.datos = datos;
      this.formulario = { ...datos.pasajero };
      const pais = this.codigosPais.find(pais => pais.code === String(this.formulario.nacionalidad || '').toUpperCase());
      if (pais) this.formulario.nacionalidad = pais.name;
      const fecha = String(this.formulario.fecha_nacimiento || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (fecha) this.formulario.fecha_nacimiento = `${fecha[3]}/${fecha[2]}/${fecha[1]}`;
      this.$i18n.locale = String(datos.idioma || 'ES').toLowerCase();
    },
    async cargar() {
      const solicitud = ++this.solicitud;
      this.guardando = false; this.cargando = true; this.errorCarga = ''; this.errorEnvio = ''; this.errores = {}; this.conflicto = false;
      const idioma = String(this.$route.params.language || 'ES').toLowerCase();
      this.$i18n.locale = ['es', 'en', 'de'].includes(idioma) ? idioma : 'es';
      try {
        const datos = await obtenerRegistroViajero(this.$route.params.hash);
        if (solicitud === this.solicitud) this.aplicar(datos);
      } catch (error) {
        if (solicitud !== this.solicitud) return;
        this.datos = null;
        this.errorCarga = error.response && error.response.status === 404 ? this.copy.noDisponible : this.copy.errorCarga;
      } finally { if (solicitud === this.solicitud) this.cargando = false; }
    },
    async guardar() {
      if (this.bloqueado || !this.datos || (this.$refs.formulario && !this.$refs.formulario.validate())) return;
      const solicitud = this.solicitud;
      this.guardando = true; this.errorEnvio = ''; this.errores = {};
      try {
        const formulario = this.campos.reduce((datos, campo) => { datos[campo] = this.formulario[campo]; return datos; }, {});
        const resultado = await completarRegistroViajero(this.$route.params.hash, this.datos.version_pasajero, formulario);
        if (solicitud === this.solicitud) {
          if (!resultado.data || !resultado.data.completado) throw new Error('No se ha confirmado el guardado');
          this.aplicar(resultado.data);
        }
      } catch (error) {
        if (solicitud !== this.solicitud) return;
        const response = error.response;
        if (response && response.status === 404) { this.datos = null; this.errorCarga = this.copy.noDisponible; }
        else if (response && response.status === 409) { this.conflicto = true; this.errorEnvio = this.$t('mensajes.datos_pasajeros.conflicto_guardado'); }
        else { this.errores = response && response.status === 422 ? response.data.errors || {} : {}; this.errorEnvio = this.copy.errorEnvio; }
      } finally { if (solicitud === this.solicitud) this.guardando = false; }
    },
  },
};
</script>
<style scoped>
.registro-viajero { min-height: 100vh; background: #eeeee7; overflow-x: hidden; }
</style>
